import script from "./SupplierSelectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierSelectModal.vue?vue&type=script&setup=true&lang=js"

import "./SupplierSelectModal.vue?vue&type=style&index=0&id=eb4a8056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb4a8056"]])

export default __exports__